import {css, StyleSheet} from "aphrodite";
import React from 'react';
import GridStyles from "../styles/styles";
import Config from "../config/Config";
import TextDiv from "./containers/TextDiv";
import Image from "./containers/Image";
import MediaQuery from "../styles/MediaQuery";

const Card = ({card, extraStyle}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define("64px 20px auto", "auto"),
            color: Config.colors.MAIN_TEXT,
            backgroundColor: Config.colors.HEADER_BACKGROUND,
            minHeight: 168,
            padding: "40px 48px",
            border: "1px solid #e9e8f3",
            boxShadow: "0 25px 60px -20px rgba(12, 5, 62, 0.15)",
            ...MediaQuery.cards({
                ...GridStyles.define("64px 16px auto", "auto"),
                border: 0,
                minHeight: 148,
                borderTop: "1px solid #e9e8f3",
                padding: "40px 32px",
            })
        },
        image: {
            ...GridStyles.setRowCol(1, 1),
            width: 64,
            height: 64,
            ...MediaQuery.mobile({
                width: 60,
                height: 60
            })
        },
        title: {
            ...GridStyles.setRowCol(3, 1),
            fontSize: 24,
            fontWeight: "bold",
            lineHeight: 1.42,
            maxWidth: 284,
            ...MediaQuery.mobile({
                maxWidth: 279
            })
        }
    });

    return (
        <div className={css(styles.container, extraStyle)}>
            <Image src={card.image} extraStyle={styles.image}/>
            <TextDiv text={card.title} extraStyle={styles.title}/>
        </div>
    );
};

export default Card;
